/* For use with embla only - prevents overscrolling on the carousel - 
https://github.com/davidjerleke/embla-carousel/issues/42#issuecomment-895850425 
*/

export const usePreventEdgeScrolling = (embla: any) => {
  const { limit, target, location, scrollTo } = embla.internalEngine()

  return () => {
    if (limit.reachedMax(target.get())) {
      if (limit.reachedMax(location.get())) location.set(limit.max)
      target.set(limit.max)
      scrollTo.distance(0, false)
    }
    if (limit.reachedMin(target.get())) {
      if (limit.reachedMin(location.get())) location.set(limit.min)
      target.set(limit.min)
      scrollTo.distance(0, false)
    }
  }
}
